import { useMutation } from '@tanstack/react-query';

export default function useSuggestSharedJobPosts(candidateProfileId: number) {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ shared_job_post_ids }: { shared_job_post_ids: number[] }) => {
      const response = await fetch('/agent/api/shared_job_posts/suggest', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          shared_job_post_ids: shared_job_post_ids,
          candidate_profile_ids: [candidateProfileId],
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(JSON.stringify(errorData));
      }

      const data = await response.json();
      return data;
    },
  });
}
